import { PaginatedResponse } from '@/shared/types/api';
import { fetchApi } from '@/shared/api/fetchApi';
export interface Client {
  id: string;
  client_type: 'private' | 'business';
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  country: string;
  city: string;
  address: string;
  post_index?: string;
  language: string;
  verification_status: 'new' | 'verified' | 'verification_needed';
  is_email_confirmed: boolean;
  is_phone_confirmed: boolean;
  registered_at: string;
}

interface GetClientsParams {
  offset: number;
  limit: number;
  filters?: {
    country?: string;
    verification_status?: 'new' | 'verified' | 'verification_needed';
    registration_start_date?: string;
    registration_end_date?: string;
  };
  sort?: {
    registration_date: 'asc' | 'desc';
  };
}

export type ClientsResponse = PaginatedResponse<Client>;

export const clientsApi = {
  getClients: async (params: GetClientsParams): Promise<ClientsResponse> => {
    const searchParams = new URLSearchParams({
      offset: params.offset.toString(),
      limit: params.limit.toString()
    });

    const body: Omit<GetClientsParams, 'offset' | 'limit'> = {};

    if (params.filters) {
      body.filters = params.filters;
    }
    if (params.sort) {
      body.sort = params.sort;
    }

    return fetchApi<ClientsResponse>(`/api/v1/clients/list?${searchParams.toString()}`, {
        method: 'POST',
        body: JSON.stringify(body),
      }
    );
  },

  getClientById: async (id: string): Promise<Client> => {
    return fetchApi<Client>(`/api/v1/clients/${id}`);
  },

  blockClient: async (id: number): Promise<void> => {
    await fetchApi(`/api/v1/clients/${id}/block`, {
      method: 'POST',
    });
  },

  unblockClient: async (id: number): Promise<void> => {
    await fetchApi(`/api/v1/clients/${id}/unblock`, {
      method: 'POST',
    });
  }
};
